import React from 'react';
import PropTypes from 'prop-types';
import threeDImg from '../lib/threeDImg';

class ImageAnaglyph extends React.Component {
    componentDidMount() {
        const holder = this.holder;
        threeDImg(this.props.sources, this.props.options.type, holder);
    }

    render() {
        return (
            <div ref={(c) => {
                this.holder = c;
            }} className="img3d">
                <img src={this.props.sources.left} alt="" className="imgPlaceholder"/>
            </div>
        );
    }
}

ImageAnaglyph.propTypes = {
    sources: PropTypes.object,
    options: PropTypes.object
};

export default ImageAnaglyph;
